export default {
	button: {
		'&:hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.04)'
		}
	}
};
